var map = {
	"./BMX.svg": "iuLF",
	"./HIIT.svg": "WeHi",
	"./乒乓球.svg": "qgdL",
	"./体感游戏.svg": "lrMO",
	"./体操.svg": "eoMB",
	"./保龄球.svg": "7zyq",
	"./俯卧撑.svg": "Phla",
	"./健走.svg": "maXq",
	"./健身操.svg": "RW40",
	"./冰壶.svg": "foeI",
	"./冰球.svg": "tnKC",
	"./冲浪.svg": "0nYC",
	"./击剑.svg": "zIOt",
	"./划船机.svg": "m+Jl",
	"./匹克球.svg": "hDU5",
	"./单杠.svg": "a8OG",
	"./单板滑雪.svg": "CaZr",
	"./卷腹.svg": "VvXm",
	"./双杠.svg": "PN1c",
	"./双板滑雪.svg": "RlNr",
	"./台球.svg": "Fujq",
	"./垒球.svg": "Z9WR",
	"./壁球.svg": "JebN",
	"./太极拳.svg": "Dz6k",
	"./室内单车.svg": "eBh1",
	"./室内攀岩.svg": "G7kD",
	"./室内步行.svg": "PgtT",
	"./室内游泳.svg": "TiAE",
	"./室内滑冰.svg": "nz37",
	"./室内跑.svg": "NNcf",
	"./射箭.svg": "bCVf",
	"./帆板.svg": "tAHs",
	"./平板支撑.svg": "QlQk",
	"./徒步穿越.svg": "WepO",
	"./户外攀岩.svg": "VJow",
	"./户外游泳.svg": "jS8e",
	"./户外滑冰.svg": "vkK2",
	"./手球.svg": "ve0m",
	"./拳击.svg": "FLLF",
	"./排球.svg": "FU4b",
	"./摔跤.svg": "OnkU",
	"./摩托艇.svg": "QpX4",
	"./操场跑.svg": "upA/",
	"./普拉提.svg": "prNM",
	"./曲棍球.svg": "th4t",
	"./有氧运动.svg": "oLKy",
	"./板球.svg": "vR2h",
	"./棒球.svg": "gZ54",
	"./椭圆机.svg": "PzUN",
	"./橄榄球.svg": "y1VT",
	"./武术.svg": "R9o8",
	"./水球.svg": "p/HJ",
	"./浮潜.svg": "k3ad",
	"./深蹲.svg": "gkNE",
	"./滑板.svg": "94EE",
	"./滑水.svg": "Zx2e",
	"./滑雪登山.svg": "tPpS",
	"./漂流.svg": "ZlUt",
	"./漫步机.svg": "wYyk",
	"./爬楼.svg": "OAZf",
	"./爬楼机.svg": "KFnh",
	"./瑜伽.svg": "5jQd",
	"./登山.svg": "WBrR",
	"./皮划艇.svg": "GDMT",
	"./空手道.svg": "BKE7",
	"./篮球.svg": "+usw",
	"./网球.svg": "u+80",
	"./羽毛球.svg": "yAkb",
	"./自由训练.svg": "TZ22",
	"./舞蹈.svg": "/2pX",
	"./赛艇.svg": "9iRD",
	"./赛车.svg": "qE3j",
	"./越野摩托.svg": "Vhu4",
	"./越野滑雪.svg": "j2lt",
	"./越野跑.svg": "WAuU",
	"./越野骑行.svg": "fIWE",
	"./足球.svg": "4uPg",
	"./跆拳道.svg": "RFZ6",
	"./跑步.svg": "YFS7",
	"./跑酷.svg": "VEH5",
	"./跳伞.svg": "o651",
	"./跳水.svg": "nKbi",
	"./跳绳.svg": "U0Ew",
	"./踏步机.svg": "wzB8",
	"./蹦极.svg": "Wcst",
	"./轮滑.svg": "Q9OP",
	"./钓鱼.svg": "MOaw",
	"./铁人三项.svg": "p+lm",
	"./门球.svg": "vKO+",
	"./障碍赛跑.svg": "hCkN",
	"./雪地摩托.svg": "p3uT",
	"./雪橇.svg": "itEL",
	"./雪车.svg": "tkOp",
	"./雪鞋徒步.svg": "Zvmf",
	"./风筝冲浪.svg": "8QNh",
	"./飞盘.svg": "JeeT",
	"./马拉松.svg": "oD66",
	"./骑行.svg": "Ae/O",
	"./骑马.svg": "NckF",
	"./龙舟.svg": "knJM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yC2q";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/home ^\.\/.*\.svg$
// module id = yC2q
// module chunks = 0